import { createFileRoute } from '@tanstack/react-router'
import { SiteInspectionEditorPage } from '@/features/site-inspections/editor'

export const Route = createFileRoute('/site-inspections_/new')({
  component: SiteInspectionEditorPage,
})
